import axios from 'axios'
import { Collapse, Modal, Tooltip } from 'bootstrap'
import Cookies  from 'js-cookie'
import Cleave from 'cleave.js'
import Slideout from 'slideout'
import { tns } from 'tiny-slider/src/tiny-slider'

// Make some packages globally-available.
window.culligan = window.culligan || {}
window.culligan.Cookies = Cookies
window.culligan.Modal = Modal

/**
 * Collect parameters from the URL and send to the server.
 * 
 * Certain parameters (e.g. utm) are collected and stored 
 * for tracking purposes, and must be sent to the server via
 * ajax due to WPEngine caching.
 * 
 * @see https://wpengine.com/support/cookies-and-php-sessions/#Use_Admin-ajax_Calls
 */
if (window.location.search) {
  const params = new URLSearchParams(window.location.search)
  params.append('action', 'culligan_v4_collectAndStoreUtmParams')

  axios.post(window.ajaxurl, params)
}

/**
 * Slideshow.
 * 
 * @see https://github.com/ganlanyuan/tiny-slider
 */
if (document.querySelector('.slideshow .slides')) {
  const slider = tns({
    container: '.slideshow .slides',
    items: 1,
    mode: 'gallery',
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: true,
    controlsContainer: false,
    // controlsText: [
    //   '<svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#FFFFFF" d="M166.5 424.5l-143.1-152c-4.375-4.625-6.562-10.56-6.562-16.5c0-5.938 2.188-11.88 6.562-16.5l143.1-152c9.125-9.625 24.31-10.03 33.93-.9375c9.688 9.125 10.03 24.38 .9375 33.94l-128.4 135.5l128.4 135.5c9.094 9.562 8.75 24.75-.9375 33.94C190.9 434.5 175.7 434.1 166.5 424.5z"></path></svg>',
    //   '<svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#FFFFFF" d="M89.45 87.5l143.1 152c4.375 4.625 6.562 10.56 6.562 16.5c0 5.937-2.188 11.87-6.562 16.5l-143.1 152C80.33 434.1 65.14 434.5 55.52 425.4c-9.688-9.125-10.03-24.38-.9375-33.94l128.4-135.5l-128.4-135.5C45.49 110.9 45.83 95.75 55.52 86.56C65.14 77.47 80.33 77.87 89.45 87.5z"></path></svg>'
    // ],
    prevButton: document.querySelector('.slideshow .btn-prev'),
    nextButton: document.querySelector('.slideshow .btn-next'),
    nav: false,
    lazyload: true,
  })
}

/**
 * Condense nav and add a drop shadow to the header on scroll.
 */
if (document.querySelector('.app-header')) {
  window.addEventListener('scroll', () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
    const body = document.querySelector('body')

    if (scrollTop > document.querySelector('.app-header').clientHeight) {
      body.classList.add('header-condensed')
    } else {
      body.classList.remove('header-condensed')
    }
  })
}

/**
 * Scroll to element.
 */
const scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (const scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    const selector = scrollToElement.dataset.scrollTo
    const offsetTop = document.querySelector(selector).offsetTop

    scroll({
      top: offsetTop,
      behavior: 'smooth',
    })
  })
}

/**
 * Collapse.
 */
const collapseElementList = [].slice.call(document.querySelectorAll('.collapse'))
const collapseList = collapseElementList.map(collapseEl => {
  return new Collapse(collapseEl, {
    toggle: false,
  })
})

/**
 * Tooltips.
 */
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

/**
 * Slideout Nav.
 * 
 * @see https://github.com/mango/slideout
 */
if (document.getElementById('app-nav-mobile')) {
  const slideout = new Slideout({
    panel: document.getElementById('app-panel'),
    menu: document.getElementById('app-nav-mobile'),
    padding: 320,
    tolerance: 70,
    side: 'right',
    touch: false,
  })

  document.querySelector('.nav-icon').addEventListener('click', () => {
    slideout.toggle()
  })

  document.querySelector('#app-nav-mobile .close-icon').addEventListener('click', () => {
    slideout.close()
  })
}

// Sub-menus
document.querySelectorAll('#app-nav-mobile .nav-link').forEach(link => {
  link.addEventListener('click', (e) => {
    if (e.target.getAttribute('href') == '#') {
      const btn = e.target.nextElementSibling
      const myCollapse = document.querySelector(btn.getAttribute('data-bs-target'))
      const bsCollapse = new Collapse(myCollapse, {
        toggle: true,
      })
    }
  })
})

/**
 * Mask phone inputs.
 */
document.querySelectorAll('input[type="tel"]').forEach(el => {
  new Cleave(el, {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ["(", ")", " ", "-"],
  })
})

/**
 * Mask numeric inputs.
 */
document.querySelectorAll('input.numeric, input.currency, input.percentage').forEach(el => {
  new Cleave(el, {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
  })
})

/**
 * Add the native HTML `required` attribute to all form fields
 * that have `aria-required="true"`.
 */
function setFormRequiredAttributes() {
  document.querySelectorAll('[aria-required="true"]').forEach(el => {
    el.setAttribute('required', true)
  })
}

document.addEventListener('DOMContentLoaded', () => setFormRequiredAttributes())

document.addEventListener('gform/post_render', (event) => {
  setFormRequiredAttributes()
})
